import { defineStore } from 'pinia';

// import { useQuery } from '@vue/apollo-composable';
// import { getGraphqlSchema } from '../graphql/index';

/*
  Code to remove from localStorage the previous properties from store that used to be persisted (ex: token)
*/
let persistedState = localStorage.getItem('main');
if (persistedState) {
  persistedState = JSON.parse(persistedState);

  if (persistedState.token) {
    delete persistedState.token;

    localStorage.setItem('main', JSON.stringify(persistedState));
  }
}
const useMainStore = defineStore('main', {
  state: () => ({
    loading: false,
    collaborator: null,
    group: null,
    roles: [],
    workspaces: [],
    contentTypes: [],
    include: [],
    addGroupMode: false,
    addCollaboratorMode: false,
    search: {
      query: '',
      page: 1
    },
    callCenterMode: {
      status: false,
      returnUrl: null
    },
    helloMode: {
      status: false,
      returnUrl: null
    }
  }),
  getters: {
    getCallCenterData: state => state.callCenterMode,
    getHelloData: state => state.helloMode
  },
  actions: {
    cleanSearch () {
      this.search.query = '';
      this.search.page = 1;
    }

  },
  persist: { paths: [] }
});

// eslint-disable-next-line import/prefer-default-export
export { useMainStore };
